<template>
    <section>
        <div class='container'>
            <div class='text-title'>
                Entering an Activation Code
                <p class='text-caption text-italic' runat='server'>Applies to: {{ appliesToText }}</p>
            </div>
            <p>
                Once you receive your activation code, follow the instruction below to enter it into your copy of the software.
            </p>

            <p>
                If you encounter any difficulties with your Activation Code, see the <router-link to='/Support/Help/Troubleshoot'>Troubleshooting</router-link> page.
            </p>

            <ol class='help-listStyle q-mt-lg'>
                <li>
                    Run the program <span class='text-weight-medium'>on the computer that you want activated</span>.
                </li>
                <li>
                    <p>If the Activation window does not automatically open, click the <span class='text-weight-medium'>Activate</span> link.</p>
                    <img class="img-fit" :src="require('@/assets/img/help/Activate Link.jpg')" />
                </li>
                <li>
                    <p>You now have two options to proceed:</p>
                    <span class='text-subtitle'>Manual Input Option</span>
                    <ol type='i'>
                        <li>
                            <p>
                                Enter the code in the <span class='text-weight-medium'>Activation Code</span> field. Enter the code exactly,
                                including the dashes.
                            </p>
                            <img class="img-fit" :src="require('@/assets/img/help/AC field.jpg')" />
                        </li>
                        <li>
                            Click the <span class='text-weight-medium'>Apply</span> button.
                        </li>
                    </ol>
                    <span class='text-subtitle'>Automated Retrieval Option</span>
                    <ol type='i'>
                        <li>
                            <p>Click the green <span class='text-weight-medium'>Update Activation</span> button.</p>
                            <img class="img-fit" :src="require('@/assets/img/help/UpdateActivation.jpg')" />
                        </li>
                        <li>
                            Complete the login when prompted.
                        </li>
                        <li>
                            The activation code will be retrieved and automatically applied to your computer.
                            Just click <span class='text-weight-medium'>OK</span> after it is completed.
                        </li>
                    </ol>
                </li>
            </ol>
        </div>
    </section>
</template>
<script>
    import { productLines } from '@/plugins/productLines'
    export default {
        name: 'enter-activation',
        data() {
            return {
                appliesToText: productLines.LoopCAD.name + ' ' + productLines.LoopCAD.year + ', '
                    + productLines.HeatCAD.name + ' ' + productLines.HeatCAD.year + ', '
                    + productLines.PlumbingCAD.name + ' ' + productLines.PlumbingCAD.year
            }
        }
    }
</script>

